import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PaymentSubscriptionComponent } from './payment-subscription/payment-subscription.component';
import { RoleSignupComponent } from './role-signup/role-signup.component';
import { SelectFeatureSubscriptionComponent } from './select-feature-subscription/select-feature-subscription.component';
import { SignupComponent } from './signup/signup.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentFailureComponent } from './payment-failure/payment-failure.component';
import { PrintReceiptComponent } from './print-receipt/print-receipt.component';
import { SubcriptionEndComponent } from './subcription-end/subcription-end.component';
import { TermConditionPageComponent } from './term-condition-page/term-condition-page.component';
import { VerifyOtpForgotPasswordComponent } from './verify-otp-forgot-password/verify-otp-forgot-password.component';
import { ChangeForgotPasswordComponent } from './change-forgot-password/change-forgot-password.component';
import { RoleSelectionComponent } from './role-selection/role-selection/role-selection.component';
import { LoginEmployeeComponent } from './login-employee/login-employee.component';




const routes: Routes = [
  {
    path: "role-selection",
    component: RoleSelectionComponent,

  },
  // {
  //   path: "login",
  //   component: LoginComponent,

  // },
  // {
  //   path: "login-employee",
  //   component: LoginEmployeeComponent,

  // },
  {
    path: "logout",
    component: LogoutComponent

  },
  {
    path: "register",
    component: SignupComponent
  },
  {
    path: "term-and-condition",
    component: TermConditionPageComponent
  },

  {
    path: "select-feature",
    component: SelectFeatureSubscriptionComponent
  },
  {
    path: "forget-password",
    component: ForgotPasswordComponent
  },
  {
    path:'verify-password',  // this component is not used anymore so we did not work on this component
    component:VerifyOtpForgotPasswordComponent
  },
  {
    path:'change-forgot-password',
    component:ChangeForgotPasswordComponent
  },
  {
    path: "subscription",
    component: SubscriptionComponent
  },
  {
    path: "subscription-end",
    component: SubcriptionEndComponent
  },
  {
    path: "payment-subscription/:id/:paymentId/:userSubsId",
    component: PaymentSubscriptionComponent
  },
  {
    path: "role-signup",
    component: RoleSignupComponent
  },
  {
    path: "print-receipt",
    component: PrintReceiptComponent,
  },
  {
    path: "reset-password",
    component: PasswordResetComponent
  },
  {
    path: "payment-success",
    component: PaymentSuccessComponent
  },
  {
    path: "payment-failure",
    component: PaymentFailureComponent
  },

  { path: "", redirectTo: "role-selection", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
